$(document).ready(function() {
	$('.filterButton').click(function(){

		if ($(this).hasClass('active')) {
			window.location=window.location.href.split("?")[0];
		} else {
			window.location='?area='+$(this).data('id');
		}
	});

	if ( window.location.href.indexOf("?") > -1 ) {
		$('.filter-results').show();
		$('html, body').animate({
			scrollTop: $("#departamentos").offset().top - 200
		}, 1);
	} else {
		$('.filter-results').hide();
		$('html, body').animate({
			scrollTop: 0
		}, 1);
	}

});



// WEBPACK FOOTER //
// ./assets/js/components/buttonFilter.js